import { ITournamentGame } from "../interfaces/tournament";
import { tournamentApiService } from "../api";
import { authStore, tournamentStore } from "../stores";

class TournamentService {

  checkAndSetActiveTournament = async (gameId: number, partnerId: number) => {
    const data = await tournamentApiService.getActiveTournaments(gameId, partnerId, authStore.currency!);
    const tournament = data[0];
    if (tournament) {
      tournamentStore.setActiveTournament(tournament)
    }
  }

  async fetchTournamentGames(tournamentId: number): Promise<ITournamentGame[]> {
    // Check if games are already cached
    if (tournamentStore.tournamentGames.has(tournamentId)) {
      return tournamentStore.tournamentGames.get(tournamentId) || [];
    }

    tournamentStore.setLoadingGames(true);
    try {
      const games = await tournamentApiService.getTournamentGames(tournamentId);
      const gamesArray = Array.isArray(games) ? games : [games];
      tournamentStore.setTournamentGames(tournamentId, gamesArray);
      return gamesArray;
    } catch (error) {
      console.error('Error fetching tournament games:', error);
      tournamentStore.setTournamentGames(tournamentId, []);
      return [];
    } finally {
      tournamentStore.setLoadingGames(false);
    }
  }

  async fetchTournamentLeaderboard(tournamentId: number): Promise<void> {
    try {
      tournamentStore.setLoadingLeaderboard(true);

      // Fetch current user position
      const currentUserParticipant = await tournamentApiService.getCurrentUserLeaderboardPosition(tournamentId);
      if (currentUserParticipant) {
        tournamentStore.setCurrentUserParticipant(tournamentId, currentUserParticipant);
      }

      // Fetch top participants for podium
      const topParticipants = await tournamentApiService.getTopPlayers(tournamentId, 10);
      tournamentStore.setTopPlayers(tournamentId, topParticipants);

    } catch (error) {
      console.error('Error fetching tournament leaderboard:', error);
    } finally {
      tournamentStore.setLoadingLeaderboard(false);
    }
  }

}

export const tournamentService = new TournamentService();
